import styled from 'styled-components';
import React from 'react';

import { Copy, createTablerIcon } from '@ovpn-ui/icons';
import { colors, media } from '@ovpn-ui/styles';

export const CopyIdIcon = createTablerIcon({
    Content() {
        return (
            <>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 4.583A2.417 2.417 0 0 0 4.583 7v6.667A2.417 2.417 0 0 0 7 16.083h.916V17a2.417 2.417 0 0 0 2.417 2.417H17A2.417 2.417 0 0 0 19.416 17v-6.667A2.417 2.417 0 0 0 17 7.917h-.917V7a2.417 2.417 0 0 0-2.417-2.417H7Zm8.315 4.834a.731.731 0 0 0 .036 0H17c.506 0 .916.41.916.916V17c0 .506-.41.917-.916.917h-6.667A.917.917 0 0 1 9.416 17v-6.667c0-.506.41-.916.917-.916h4.982Zm-.732-1.5V7a.917.917 0 0 0-.917-.917H7A.917.917 0 0 0 6.083 7v6.667a.916.916 0 0 0 .917.916h.916v-4.25a2.417 2.417 0 0 1 2.417-2.416h4.25Z"
                    fill="currentColor"
                />
                <path
                    d="M12.385 11.636V16H11.33v-4.364h1.055ZM14.66 16h-1.613v-4.364h1.61c.445 0 .828.088 1.15.262.322.174.57.424.745.75.175.326.262.715.262 1.168 0 .455-.087.845-.262 1.172a1.792 1.792 0 0 1-.744.752c-.322.173-.705.26-1.148.26Zm-.558-.9h.518c.244 0 .45-.04.62-.123a.817.817 0 0 0 .385-.407c.088-.189.132-.44.132-.754s-.044-.564-.132-.75a.815.815 0 0 0-.39-.405 1.422 1.422 0 0 0-.63-.125h-.503V15.1Z"
                    fill="currentColor"
                />
            </>
        );
    },
    name: 'copy-id',
    predefinedProps: {
        stroke: 'none',
        size: 24,
    },
});

export const CopyIcon = styled(Copy)<{
    $mY?: any;
    $copied?: boolean;
    $visible?: boolean;
    $color?: string;
}>`
    flex-shrink: 0;
    margin: ${({ $mY }) => ($mY ? `${$mY}px 0 ${$mY}px 7px` : '0 0 0 7px')};
    padding-right: 1px;

    color: ${t => (t.$copied ? colors.green : t.$color ?? colors.darkSlateBlue)};

    opacity: ${t => (t.$visible ? 1 : 0)};

    transition:
        opacity 125ms linear,
        color 125ms linear;
`;

export const StypedCopyIdIcon = styled(CopyIdIcon)<{ $copied?: boolean }>`
    flex-shrink: 0;
    margin: -5px 0 0 6px;

    color: ${t => (t.$copied ? colors.green : colors.neutralTextSubtitle)};

    transform: translate(2px, 4px);
    opacity: 1;

    transition: color 125ms linear;
`;

export const CopyCellWrapper = styled.span<{ $inline: boolean; $onlyIconClick: boolean }>`
    display: ${t => (t.$inline ? 'inline-flex' : 'flex')};
    flex-shrink: 0;
    align-items: center;
    max-width: 100%;
    overflow: hidden;

    cursor: ${t => (t.$onlyIconClick ? 'default' : 'pointer')};

    &:hover ${CopyIcon} {
        opacity: 1;
    }

    ${media.SM`
        display: inline-flex;
    `}
`;
